// Ridge & River Rewards page — behaviour for sections/rr-rewards.liquid
(function () {
  'use strict';

  var root = document.getElementById('rrw-root');
  if (!root) return;

  var LOGGED_IN = root.dataset.loggedIn === 'true';
  var DEBUG = /[?&]rrwdebug=1/.test(location.search);
  var state = { cfg: null, customer: null, inFlight: false };

  function log() { if (DEBUG) console.log.apply(console, ['[rewards]'].concat([].slice.call(arguments))); }
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return [].slice.call((el || root).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(n) { return Number(n || 0).toLocaleString('en-US'); }
  function money(n) {
    var v = Number(n || 0);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function icon(key) {
    var tpl = document.getElementById('rrw-icons');
    var el = tpl && (tpl.content.querySelector('[data-icon="' + key + '"]') || tpl.content.querySelector('[data-icon="default"]'));
    return el ? el.innerHTML : '';
  }
  function announce(msg) { var l = document.getElementById('rrw-live'); if (l) l.textContent = msg; }

  // ── Program rules from Rivo ────────────────────────────────────────────
  function waitForRivo(cb, tries) {
    tries = tries || 0;
    if (window.Rivo && window.Rivo.loy_config) return cb();
    if (tries > 50) return log('window.Rivo never appeared');
    setTimeout(function () { waitForRivo(cb, tries + 1); }, 120);
  }

  function activeEarnRules(cfg) {
    return (cfg.ways_to_earn || []).filter(function (w) {
      return w && w.status !== 'inactive' && !w.hidden_from_ui;
    });
  }
  function activeRewards(cfg) {
    return (cfg.points_rewards || []).filter(function (r) { return r && r.enabled !== false; })
      .sort(function (a, b) { return a.points_amount - b.points_amount; });
  }

  function rewardHeadline(r) {
    if (r.reward_type === 'fixed_amount') return { big: money(r.reward_value), small: 'off your order' };
    if (r.reward_type === 'percentage') return { big: Number(r.reward_value) + '%', small: 'off your order' };
    if (r.reward_type === 'free_shipping') return { big: 'Free', small: 'shipping' };
    return { big: '', small: r.name || 'Reward' };
  }

  function earnText(w) {
    if (w.points_type === 'multiplier') {
      var base = Number(w.currency_base_amount || 1);
      return num(w.points_amount) + ' points for every ' + money(base) + ' spent';
    }
    return num(w.points_amount) + ' points';
  }

  function fillTokens(cfg) {
    var rules = activeEarnRules(cfg);
    var signup = rules.find(function (w) { return w.trigger === 'customer_member_enabled'; });
    var order = rules.find(function (w) { return w.trigger === 'order_placed'; });
    var first = activeRewards(cfg)[0];
    var t = {};
    if (signup) {
      t.signup = num(signup.points_amount) + ' points';
      t['signup-short'] = '+' + num(signup.points_amount) + ' pts';
    }
    if (order && order.points_type === 'multiplier') {
      var base = Number(order.currency_base_amount || 1);
      t.rate = num(order.points_amount) + ' points for every ' + money(base);
      t['rate-short'] = num(order.points_amount) + ' pts per ' + money(base);
    }
    if (first) {
      var h = rewardHeadline(first);
      t['first-reward'] = num(first.points_amount) + ' points = ' + (h.big ? h.big + ' off' : first.name);
      t['first-reward-short'] = num(first.points_amount) + ' pts = ' + (h.big || first.name);
    }
    if (order && order.points_type === 'multiplier' && first && first.reward_type === 'fixed_amount') {
      var perDollar = Number(order.points_amount) / Number(order.currency_base_amount || 1);
      var pct = perDollar * Number(first.reward_value) / Number(first.points_amount) * 100;
      t.pct = (Math.round(pct * 10) / 10) + '%';
    }
    Object.keys(t).forEach(function (k) {
      $$('[data-rrw="' + k + '"]').forEach(function (el) { el.textContent = t[k]; });
    });
  }

  // ── Ways to earn ───────────────────────────────────────────────────────
  function socialDone(trigger) {
    var c = state.customer;
    if (!c) return false;
    var list = [].concat(c.social_actions || [], c.completed_actions || []);
    return list.some(function (a) {
      return a === trigger || (a && (a.action === trigger || a.trigger === trigger || a.name === trigger));
    });
  }

  function renderEarn() {
    var host = $('[data-rrw-earn]');
    if (!host) return;
    var rules = activeEarnRules(state.cfg);
    host.innerHTML = rules.map(function (w) {
      var action = '';
      if (w.trigger === 'customer_member_enabled') {
        action = LOGGED_IN
          ? '<span class="rrw-done">' + icon('done') + ' You’re a member</span>'
          : '<a class="rrw-btn rrw-btn--dark rrw-btn--sm" href="' + esc(root.dataset.registerUrl) + '">Join now</a>';
      } else if (w.trigger === 'order_placed') {
        action = '<a class="rrw-btn rrw-btn--outline rrw-btn--sm" href="' + esc(root.dataset.shopUrl) + '">Start shopping</a>';
      } else if (w.social && w.url) {
        if (!LOGGED_IN) {
          action = '<a class="rrw-btn rrw-btn--outline rrw-btn--sm" href="' + esc(root.dataset.loginUrl) + '">Sign in to earn</a>';
        } else if (socialDone(w.trigger)) {
          action = '<span class="rrw-done">' + icon('done') + ' Points earned</span>';
        } else {
          action = '<button type="button" class="rrw-btn rrw-btn--dark rrw-btn--sm" data-rrw-social="' + esc(w.trigger) + '" data-url="' + esc(w.url) + '">' + esc(w.button_text || socialLabel(w.trigger)) + '</button>';
        }
      }
      return '<div class="rrw-tile">' +
        '<span class="rrw-tile__icon">' + icon(w.trigger) + '</span>' +
        '<h3>' + esc(w.title || w.name || 'Earn points') + '</h3>' +
        '<p class="rrw-tile__earn">' + esc(earnText(w)) + '</p>' +
        (action ? '<div class="rrw-tile__action">' + action + '</div>' : '') +
        '</div>';
    }).join('');
  }
  function socialLabel(trigger) {
    if (/instagram|tiktok|twitter/.test(trigger)) return 'Follow us';
    if (/facebook/.test(trigger)) return 'Like us';
    return 'Go';
  }

  // ── Ways to redeem ─────────────────────────────────────────────────────
  function balance() { return state.customer ? Number(state.customer.points_tally || 0) : null; }

  function rewardAction(r) {
    if (!LOGGED_IN) {
      return '<a class="rrw-btn rrw-btn--outline rrw-btn--block" href="' + esc(root.dataset.loginUrl) + '">Sign in to redeem</a>';
    }
    var bal = balance();
    if (bal === null) {
      return '<button type="button" class="rrw-btn rrw-btn--dark rrw-btn--block" disabled>Redeem</button>';
    }
    if (bal >= r.points_amount) {
      return '<button type="button" class="rrw-btn rrw-btn--primary rrw-btn--block" data-rrw-redeem="' + r.id + '">Redeem</button>';
    }
    var need = r.points_amount - bal;
    var pct = Math.max(0, Math.min(100, Math.round(bal / r.points_amount * 100)));
    return '<button type="button" class="rrw-btn rrw-btn--dark rrw-btn--block" disabled>Redeem</button>' +
      '<div class="rrw-progress" aria-hidden="true"><div class="rrw-progress__bar" style="width:' + pct + '%"></div></div>' +
      '<p class="rrw-reward__need">' + num(need) + ' more points to go</p>';
  }

  function renderRewards() {
    var host = $('[data-rrw-rewards]');
    if (!host) return;
    host.innerHTML = activeRewards(state.cfg).map(function (r) {
      var h = rewardHeadline(r);
      return '<div class="rrw-tile rrw-reward" data-reward-id="' + r.id + '">' +
        (h.big ? '<p class="rrw-reward__value">' + esc(h.big) + '</p><p class="rrw-reward__label">' + esc(h.small) + '</p>'
               : '<span class="rrw-tile__icon" style="margin:0 auto 12px">' + icon('reward') + '</span><h3>' + esc(r.name) + '</h3>') +
        '<span class="rrw-reward__cost">' + num(r.points_amount) + ' points</span>' +
        (r.pretty_terms_of_service ? '<p class="rrw-reward__need">' + esc(r.pretty_terms_of_service) + '</p>' : '') +
        '<div class="rrw-tile__action" data-rrw-action>' + rewardAction(r) + '</div>' +
        '</div>';
    }).join('');
  }

  function codeBox(code, message) {
    var apply = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart';
    return '<div class="rrw-code">' +
      (message ? '<p class="rrw-code__msg">' + esc(message) + '</p>' : '') +
      '<div class="rrw-code__box"><span class="rrw-code__text">' + esc(code) + '</span>' +
      '<button type="button" class="rrw-code__copy" data-rrw-copy="' + esc(code) + '">Copy</button></div>' +
      '<a class="rrw-btn rrw-btn--dark rrw-btn--sm rrw-btn--block rrw-code__apply" href="' + apply + '">Apply to cart</a>' +
      '</div>';
  }

  // ── Balance panel ──────────────────────────────────────────────────────
  function renderBalance() {
    var c = state.customer;
    var numEl = $('[data-rrw-balance]');
    if (!c || !numEl) return;
    var bal = balance();
    numEl.textContent = num(bal);
    numEl.classList.remove('rrw-skel');

    var rewards = activeRewards(state.cfg);
    var next = rewards.find(function (r) { return r.points_amount > bal; });
    var affordable = rewards.filter(function (r) { return r.points_amount <= bal; }).pop();
    var bar = $('[data-rrw-progress]');
    var text = $('[data-rrw-progress-text]');
    if (next) {
      var pct = Math.max(2, Math.min(100, Math.round(bal / next.points_amount * 100)));
      if (bar) bar.style.width = pct + '%';
      if (text) {
        text.innerHTML = '<strong>' + num(next.points_amount - bal) + ' points</strong> until ' + esc(rewardShortName(next)) +
          (affordable ? '. You can redeem ' + esc(rewardShortName(affordable)) + ' now.' : '.');
      }
    } else if (rewards.length) {
      if (bar) bar.style.width = '100%';
      if (text) text.innerHTML = 'You have enough for <strong>' + esc(rewardShortName(affordable || rewards[rewards.length - 1])) + '</strong>.';
    }
  }
  function rewardShortName(r) {
    var h = rewardHeadline(r);
    return h.big ? h.big + ' ' + h.small.replace(' your order', '') : r.name;
  }

  // ── Member area: unused codes + history ────────────────────────────────
  function renderCodes(list) {
    var host = $('[data-rrw-codes]');
    if (!host) return;
    list = (list || []).filter(function (p) { return p && p.code; });
    if (!list.length) {
      host.innerHTML = '<p class="rrw-empty">No unused codes right now. Redeem a reward above and your code will show up here.</p>';
      return;
    }
    host.innerHTML = list.map(function (p) {
      var name = (p.reward && p.reward.name) || p.name || p.reward_name || 'Reward';
      return '<div><p class="rrw-codes__name">' + esc(name) + '</p>' + codeBox(p.code) + '</div>';
    }).join('');
  }

  function logLabel(l) {
    var s = l.pretty_action || l.action_name || l.pretty_description || l.description || l.title || l.name || l.action || l.source || 'Points';
    s = String(s).replace(/_/g, ' ');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function logPoints(l) {
    var v = l.points_amount != null ? l.points_amount : (l.points != null ? l.points : l.amount);
    return Number(v || 0);
  }
  function logDate(l) {
    var d = l.created_at ? new Date(l.created_at) : null;
    return d && !isNaN(d) ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  }
  function renderHistory(logs) {
    var host = $('[data-rrw-history]');
    if (!host) return;
    logs = logs || [];
    if (!logs.length) {
      host.innerHTML = '<p class="rrw-empty">No points activity yet. Your first order will show up here.</p>';
      return;
    }
    host.innerHTML = '<ul class="rrw-log">' + logs.map(function (l) {
      var p = logPoints(l);
      var cls = p < 0 ? 'rrw-log__pts--minus' : 'rrw-log__pts--plus';
      return '<li><span><span class="rrw-log__what">' + esc(logLabel(l)) + '</span><span class="rrw-log__when">' + esc(logDate(l)) + '</span></span>' +
        '<span class="rrw-log__pts ' + cls + '">' + (p > 0 ? '+' : '') + num(p) + '</span></li>';
    }).join('') + '</ul>';
  }

  // ── Rivo API ───────────────────────────────────────────────────────────
  function loadApi() {
    return new Promise(function (resolve, reject) {
      if (window.RivoAPI) return resolve(window.RivoAPI);
      var src = window.Rivo && window.Rivo.global_config && window.Rivo.global_config.asset_urls &&
        window.Rivo.global_config.asset_urls.loy && window.Rivo.global_config.asset_urls.loy.api_js;
      if (!src) return reject(new Error('Rivo API script URL not found'));
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { window.RivoAPI ? resolve(window.RivoAPI) : reject(new Error('RivoAPI missing after load')); };
      s.onerror = function () { reject(new Error('Rivo API script failed to load')); };
      document.head.appendChild(s);
    });
  }

  function refreshCustomer(api) {
    return api.identify_customer('loggedin').then(function (c) {
      log('customer', c);
      if (!c) throw new Error('No Rivo customer');
      state.customer = c;
      renderBalance();
      renderRewards();
      renderEarn();
      return c;
    });
  }

  function loadMemberData(api) {
    var c = state.customer;
    var id = c.remote_id || c.id || 'loggedin';
    api.points_purchases(id, false).then(function (r) {
      log('unused points purchases', r);
      renderCodes(r && r.points_purchases);
    }).catch(function (e) { log(e); renderCodes([]); });
    if ($('[data-rrw-history]')) {
      api.points_logs('loggedin', 1, 10).then(function (r) {
        log('points logs', r);
        renderHistory(r && r.points_logs);
      }).catch(function (e) { log(e); renderHistory([]); });
    }
  }

  function memberError() {
    var numEl = $('[data-rrw-balance]');
    if (numEl && numEl.classList.contains('rrw-skel')) { numEl.textContent = '–'; numEl.classList.remove('rrw-skel'); }
    var text = $('[data-rrw-progress-text]');
    if (text) text.textContent = 'We couldn’t load your points just now. Refresh the page to try again.';
    ['[data-rrw-codes]', '[data-rrw-history]'].forEach(function (s) {
      var el = $(s); if (el) el.innerHTML = '<p class="rrw-empty">Couldn’t load this right now.</p>';
    });
  }

  // ── Actions ────────────────────────────────────────────────────────────
  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('button, a');
    if (!t || !root.contains(t)) return;

    if (t.hasAttribute('data-rrw-copy')) {
      ev.preventDefault();
      copyText(t.getAttribute('data-rrw-copy')).then(function () {
        t.textContent = 'Copied';
        announce('Code copied');
        setTimeout(function () { t.textContent = 'Copy'; }, 1800);
      });
      return;
    }

    if (t.hasAttribute('data-rrw-redeem')) {
      ev.preventDefault();
      var id = Number(t.getAttribute('data-rrw-redeem'));
      var r = activeRewards(state.cfg).find(function (x) { return x.id === id; });
      if (!r) return;
      var slot = t.closest('[data-rrw-action]');
      slot.innerHTML = '<p class="rrw-confirm__q">Use ' + num(r.points_amount) + ' points for ' + esc(rewardShortName(r)) + '?</p>' +
        '<div class="rrw-confirm__row">' +
        '<button type="button" class="rrw-btn rrw-btn--outline rrw-btn--sm" data-rrw-cancel>Cancel</button>' +
        '<button type="button" class="rrw-btn rrw-btn--primary rrw-btn--sm" data-rrw-confirm="' + r.id + '">Yes, redeem</button>' +
        '</div>';
      var yes = slot.querySelector('[data-rrw-confirm]');
      if (yes) yes.focus();
      return;
    }

    if (t.hasAttribute('data-rrw-cancel')) {
      ev.preventDefault();
      renderRewards();
      return;
    }

    if (t.hasAttribute('data-rrw-confirm')) {
      ev.preventDefault();
      redeem(Number(t.getAttribute('data-rrw-confirm')), t);
      return;
    }

    if (t.hasAttribute('data-rrw-social')) {
      ev.preventDefault();
      social(t.getAttribute('data-rrw-social'), t.getAttribute('data-url'), t);
    }
  });

  function redeem(rewardId, btn) {
    if (state.inFlight || !window.RivoAPI || !state.customer) return;
    var r = activeRewards(state.cfg).find(function (x) { return x.id === rewardId; });
    var slot = btn.closest('[data-rrw-action]');
    state.inFlight = true;
    $$('[data-rrw-confirm], [data-rrw-cancel], [data-rrw-redeem]').forEach(function (b) { b.disabled = true; });
    btn.textContent = 'Redeeming…';

    window.RivoAPI.redeem(state.customer.remote_id, rewardId).then(function (resp) {
      log('redeem response', resp);
      state.inFlight = false;
      var pp = resp && resp.points_purchase;
      if (!resp || resp.success !== true || !pp || !pp.code) {
        // Don't invite a blind retry: the request may have gone through.
        slot.innerHTML = '<p class="rrw-error">' + esc((resp && (resp.error || resp.message)) || 'We couldn’t finish that.') +
          ' Refresh the page to check your balance and codes before trying again.</p>';
        return;
      }
      if (resp.points_tally != null) state.customer.points_tally = resp.points_tally;
      renderBalance();
      renderRewards();
      // Show the code on the card the customer used.
      var card = root.querySelector('.rrw-reward[data-reward-id="' + rewardId + '"] [data-rrw-action]');
      if (card) card.innerHTML = codeBox(pp.code, 'Done! Here’s your code:');
      announce('Reward redeemed. Your code is ' + pp.code);
      // Refresh the unused-codes list from Rivo.
      if (state.customer) loadMemberData(window.RivoAPI);
    }).catch(function (e) {
      log(e);
      state.inFlight = false;
      slot.innerHTML = '<p class="rrw-error">Something went wrong. Refresh the page to check your balance and codes before trying again.</p>';
    });
  }

  function social(trigger, url, btn) {
    // Open the profile first (must happen inside the click for popup blockers).
    window.open(url, '_blank', 'noopener');
    if (!window.RivoAPI) return;
    btn.disabled = true;
    btn.textContent = 'Adding points…';
    window.RivoAPI.grant_social_points('loggedin', trigger).then(function (resp) {
      log('social response', resp);
      if (resp && resp.success) {
        if (resp.points_tally != null) state.customer.points_tally = resp.points_tally;
        if (resp.social_actions) state.customer.social_actions = resp.social_actions;
        else state.customer.social_actions = [].concat(state.customer.social_actions || [], trigger);
        renderBalance();
        renderRewards();
        renderEarn();
        announce('Points added');
      } else {
        btn.disabled = false;
        btn.textContent = socialLabel(trigger);
      }
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = socialLabel(trigger);
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); resolve();
    });
  }

  // ── Boot ───────────────────────────────────────────────────────────────
  function boot() {
    waitForRivo(function () {
      state.cfg = window.Rivo.loy_config;
      log('config', state.cfg);
      fillTokens(state.cfg);
      renderEarn();
      renderRewards();
      if (!LOGGED_IN) return;
      loadApi()
        .then(function (api) { return refreshCustomer(api).then(function () { loadMemberData(api); }); })
        .catch(function (e) { log(e); memberError(); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
